import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    BASE_TEXT_PX,
    DARK_GRAY_FONT_COLOR,
    DARK_NAVY_FONT_COLOR,
    FONT_FAMILY_DEMI,
    PRIMARY_FONT_COLOR,
    SEMANTIC_TEXT_SMALL_PX,
    SEMANTIC_TEXT_XSMALL_PX,
    X_LARGE_TEXT_PX,
} from '../../../../styles/fonts/MCFontConstants';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: ${({
        isReviewSubmitScreen,
        isConsignmentAdd,
        moreTemplates,
        isReviewSubmitScreenEquity,
        isTemplateDetail,
    }) =>
        moreTemplates
            ? '-2%'
            : !isReviewSubmitScreen &&
              !isTemplateDetail &&
              !isReviewSubmitScreenEquity
            ? '3%'
            : isConsignmentAdd
            ? '1%'
            : ''};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    margin: ${({ isOrderScreen }) => isOrderScreen && '0px 12px 0px 20px'};
    padding: ${({
        isReviewSubmitScreen,
        isReviewSubmitScreenEquity,
        moreTemplates,
    }) =>
        !isReviewSubmitScreen && !isReviewSubmitScreenEquity && !moreTemplates
            ? '1.2%'
            : ''};
    position: relative;
    background: #ffffff 0% 0% no-repeat padding-box;
    width: cal(100% -20px);
    box-shadow: ${({
        isReviewSubmitScreen,
        isReviewSubmitScreenEquity,
        moreTemplates,
    }) =>
        !isReviewSubmitScreen && !isReviewSubmitScreenEquity && !moreTemplates
            ? '0px 0px 6px #00000029'
            : ''};
    border-radius: ${({ isReviewSubmitScreen }) =>
        !isReviewSubmitScreen ? '6px' : ''};
    @media only screen and (max-width: 768px) {
        width: 100%;
    }
`;

export const CartActionItems = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: ${DARK_NAVY_FONT_COLOR};
    opacity: 1;
    display: flex;
    flex-direction: row;
    height: ${({ height }) => (height ? height : X_LARGE_TEXT_PX)};
    width: ${({ width }) => (width ? width : '20%')};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    margin-left: ${({ marginLeft }) =>
        marginLeft ? marginLeft : X_LARGE_TEXT_PX};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: ${DARK_GRAY_FONT_COLOR};
    font-size: ${X_LARGE_TEXT_PX};
    width : 200px,
    margin-right: ${({ marginRight }) =>
        marginRight ? marginRight : null};       
    white-space: nowrap;
    margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '0px')};
    `}
`;

export const AddIcon = styled.div`
    // display: ${({ display }) => (display ? display : 'contents')};
    // padding: ${({ padding }) => (padding ? padding : '0px 5px 2px')};
    float: ${({ float }) => (float ? float : 'right')};
    display: ${({ isReviewSubmitScreen, display }) =>
        isReviewSubmitScreen ? null : display ? display : 'contents'};
    padding: ${({ isReviewSubmitScreen, padding }) =>
        isReviewSubmitScreen ? null : padding ? padding : '0px 5px 2px'};
`;

export const Text = styled.div`
    width: ${({ width }) => (width ? width : '83px')};
    height: ${({ height }) => (height ? height : X_LARGE_TEXT_PX)};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    font-size: ${({ fontSize }) =>
        fontSize ? fontSize : SEMANTIC_TEXT_XSMALL_PX};
    font-weight: 600;
    float: ${({ float }) => (float ? float : 'left')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    color: ${({ color }) => (color ? color : '')};
    ${media.mobileDevice`
     margin-left: 0;
     `}
`;

export const SetsNotOrderScreenList = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    font-size: ${BASE_TEXT_PX};
    font-weight: bold;
    font-family: ${FONT_FAMILY_DEMI};
    color: ${PRIMARY_FONT_COLOR};
`;

export const ItemsNotOrderScreenList = styled.div`
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : BASE_TEXT_PX)};
    font-weight: bold;
    font-family: ${FONT_FAMILY_DEMI};
    color: ${PRIMARY_FONT_COLOR};
`;

export const FeesNotOrderScreenList = styled.div`
    margin-top: ${({ isOrderScreen }) => (isOrderScreen ? '5px' : '0px')};
    font-size: ${({ isOrderScreen }) => isOrderScreen && BASE_TEXT_PX};
    font-weight: bold;
    font-family: ${({ isOrderScreen }) => isOrderScreen && FONT_FAMILY_DEMI};
    color: ${({ isOrderScreen }) => isOrderScreen && PRIMARY_FONT_COLOR};
`;
